import React, { useEffect } from 'react';
import withPageComponents from '../../../page/components/with-page-components';
import usePage from '../../../hooks/usePage';
import useUserData from '../../../hooks/useUserData';
import { verifyPicks, getSelectedRecommendedConfig } from '../../util';
import useProductImpressions from '../../../hooks/useProductImpressionsV2';
import {
    getAvailableConfiguratorStartParams,
    pollPageView,
    trackImpression,
    setConfiguratorStartProduct,
    trackConfiguratorStartProduct,
} from '../../../metrics/metrics-helpers';
import { triggerConfiguratorStartEventAfterPageView } from '../../../metrics/track-params';

const EMPTY_OBJ = {};
const NULL_STATE = null;

/**
 * Component for managing pick verification on initial page load
 * @param {*} param0
 * @returns
 */
const VerifyConfig = ({ baseConfig, ctoPrice, vanityUrl, ctoProductInitial }) => {
    const { specCategories = [], catentryId, sku, recommendedConfigs } = baseConfig || EMPTY_OBJ;
    const { updateComponent } = usePage();
    const { userData } = useUserData();
    const { updatedFromService } = userData;
    //wait till HPServices response for user data before verify picks
    const profileData = updatedFromService ? userData.profileData : NULL_STATE;
    const { isccf } = profileData || {};
    useEffect(() => {
        if (specCategories && specCategories.length > 0 && profileData) {
            //call baseconfig client side for call center to get gross margin value
            if (profileData.isccf) {
                verifyPicks({ baseConfig, isCallCenter: true }, updateComponent);
            } else {
                verifyPicks({ baseConfig }, updateComponent);
            }
        } else {
            updateComponent({ verifyingPicks: true });
        }
    }, [catentryId, isccf]);
    useProductImpressions({
        products: ctoProductInitial ? [ctoProductInitial] : null,
        vanityUrl,
        list: 'cto',
        componentKey: 'ctoProductInitial',
        customPrices: ctoPrice
            ? {
                  [sku]: ctoPrice,
              }
            : {},
        isMainSku: true,
    });
    return null;
};

export default withPageComponents(VerifyConfig, {
    components: ['baseConfig', 'ctoPrice', 'errors', 'ctoProductInitial'],
});
